<!--
 - Manage assignments component.
 -
 - @author Ryan Sweeney <rsweeney@buildcentrix.com>
 - @copyright (c) 2025 Build Centrix
 -->
<div class="manage-assignments">
  <bc-templates-modal-layout
    [isLoading]="isUpdating"
    [loadingText]="('actions.loading'|translate)"
    (onCloseButtonClicked)="closeModal(false)"
  >
    <div title-content>
      {{'order.columns.shipping.assignments.manage.title'|translate: { number:
      orderNumber } }}
    </div>
    <div body-content>
      <!--Vehicle Assignments-->
      <div
        class="bcx-modal-content-container"
        *ngIf="!isUpdating && assignmentOptions?.length > 0"
      >
        <bc-atoms-input-group
          labelIcon="edit"
          labelTitle="{{'order.columns.shipping.assignments.select.title'|translate: { number: orderNumber } }}"
          labelDescription="{{'order.columns.shipping.assignments.select.description'|translate}}"
        >
          <div class="content">
            <bc-molecules-multi-select-dropdown
              id="vehicleAssignments_{{orderNumber}}"
              name="vehicleAssignments_{{orderNumber}}"
              title="{{'order.columns.shipping.assignments.description'|translate}}"
              placeholder="{{'order.columns.shipping.assignments.none.title'|translate}}"
              labelKey="label"
              selectedItemsText="{{'order.columns.shipping.assignments.title'|translate}}"
              [isCloseOnSelect]="true"
              [required]="false"
              [isDisabled]="isUpdating"
              [options]="assignmentOptions"
              [(model)]="assignments"
              [(ngModel)]="assignments"
              [maxDisplayedItems]="1"
            >
            </bc-molecules-multi-select-dropdown>
          </div>
        </bc-atoms-input-group>
      </div>
      <!--Selected Assignments-->
      <div
        class="bcx-modal-content-container"
        *ngIf="!isUpdating && assignments?.length > 0"
      >
        <bc-atoms-input-group
          labelIcon="all"
          labelTitle="{{'order.columns.shipping.assignments.title'|translate}}"
          labelDescription="{{'order.columns.shipping.assignments.description'|translate}}"
        >
          <div class="content">
            <div
              class="assigned-vehicles-container"
              [ngClass]="{ 'text-muted': isUpdating }"
            >
              <div
                *ngFor="let assignment of assignments; let last = last"
                [ngClass]="{ 'mb-2': !last }"
              >
                <div class="date">
                  {{assignment.date.start|date:wdLocalEnvironmentService.datePipeFormat}}
                  -
                  {{assignment.date.end|date:wdLocalEnvironmentService.datePipeFormat}}
                </div>
                <div class="assignment">
                  <span class="vehicle" *ngIf="assignment.vehicle">
                    <bc-atoms-icon type="shippingVehicle"></bc-atoms-icon>
                    {{assignment.vehicle.label }}
                  </span>
                  <span class="driver" *ngIf="assignment.driver">
                    <bc-atoms-icon type="user"></bc-atoms-icon> {{
                    assignment.driver.firstName }} {{ assignment.driver.lastName
                    }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </bc-atoms-input-group>
      </div>
    </div>
    <div footer-content>
      <div class="buttons-container">
        <div class="right-buttons">
          <!--Cancel/Close -->
          <bc-atoms-button
            [label]="('actions.cancel'|translate)"
            [title]="('actions.cancel'|translate)"
            [disabled]="isUpdating"
            type="default"
            icon="cancel"
            display="block"
            size="small"
            (onButtonClicked)="closeModal(false)"
          >
          </bc-atoms-button>
          <!--Save-->
          <bc-atoms-button
            [label]="('actions.save'|translate)"
            [title]="('actions.save'|translate)"
            [loading]="isUpdating"
            [disabled]="wdLocalSharedFunctionsService.isSameArray(assignments, assignmentsUntouched)"
            type="success"
            icon="ok"
            size="small"
            (onButtonClicked)="updateAssignedVehicles()"
          >
          </bc-atoms-button>
        </div>
      </div>
    </div>
  </bc-templates-modal-layout>
</div>
